import { render, staticRenderFns } from "./DosGraficos.vue?vue&type=template&id=7ab4f284&"
import script from "./DosGraficos.vue?vue&type=script&lang=js&"
export * from "./DosGraficos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports